// Rutas de front-end
import imageDefault from '../assests/img/logo_palex.png'

export const routes = {
  LANDING: '/',

  //AUTH
  RESET: '/reset', //esto se guarda tambien el BD
  LOGIN: '/login',
  FORGOT: '/forgot',

  //PUBLIC
  LGPD_POLICY: '/lgpd-policy',

  //MAIN
  MAIN: '/main',

  //PROFILE
  PROFILE: '/perfil/',
  CHANGE_PASSWORD_PROFILE: '/perfil/editarPass/',

  //BACKOFFICE
  BACKOFFICE: '/backoffice',
  USERS: '/backoffice/usuarios',
  USER_EDIT: '/backoffice/usuarios/editar/',
  USER_NEW: '/backoffice/usuarios/nuevo',
  SPECIALTIES: '/backoffice/especialidades',
  DEPARTMENTS: '/backoffice/departamentos',
  POSITIONS: '/backoffice/cargos',
  PRODUCTS: '/backoffice/productos',
  PRODUCTS_NEW: '/backoffice/productos/nuevo',
  PRODUCTS_EDIT: '/backoffice/productos/editar/',
  ARTICLES_VIEW: '/backoffice/productos/ver/',
  HOSPITALS: '/backoffice/hospitales',
  HOSPITAL_EDIT: '/backoffice/hospitales/editar/',
  HOSPITAL_NEW: '/backoffice/hospitales/nuevo',
  CATEGORIES: '/backoffice/categorías',
  BUSINESSUNITS: '/backoffice/businessunits',
  CONFIGURACIONES: '/backoffice/config',

  // MANAGEMENT
  MANAGEMENT: '/management/todasLasTareas',
  TASK_NEW: '/tareas/nueva',
  TASK_EDIT: '/tareas/editar/',
  TASK_VIEW: '/tareas/ver/',

  //CATALOGUE
  CATALOGUE_V2: '/catalogo-v2',

  //BUSCADOR v2 — banco de pruebas, sólo accesible por URL
  SEARCH_COMPARE: '/buscador-comparar',

  //PRESENTATION
  PRESENTATION: '/presentacion',
  PRESENTATION_ADD_PRODUCTS: '/presentacion/añadirProductos/',
  PRESENTATION_EDIT: '/presentacion/editar/',
  PRESENTATION_VIEW: '/presentacion/ver/',

  //CONTACTS
  CONTACTS: '/contactos',
  CONTACT_NEW: '/contactos/nuevo',
  CONTACTS_ADD_HOSPITAL_TO_CONTACT: '/contactos/añadirHospitalContacto/',
  CONTACT_EDIT: '/contactos/editar/',
  CONTACT_EDIT_CONTACT: '/contactos/editar/contacto/',
  CONTACT_EDIT_CONTACT_HOSPITAL: '/contactos/editar/hospital/',
  CONTACT_DETAIL: '/contactos/ver/',

  //ACCESS TO PRESENTATION BY CONTACT
  LANDING_ACCESS_TO_PRESENTATION_BY_CONTACT: '/palex/presentacion/', //esto se guarda tambien el BD
  VIEW_CONTACT_PRESENTATION: '/ver/presentacion/',

  //CALENDAR
  CALENDAR: '/calendario',

  //Estadisticas
  STATISTICS: '/estadisticas',

  //Eventos
  EVENTOS: '/eventos',
  SEGUIMIENTO_COMERCIAL: '/seguimiento-comercial',

  //CRM
  CRM: '/crm',
}

// export const ROUTE_IMG_DEFAULT = "https://www.publicdomainpictures.net/pictures/280000/velka/not-found-image-15383864787lu.jpg"
export const ROUTE_IMG_DEFAULT = imageDefault
